var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    width: "200px",
    height: "199.42px",
    viewBox: "0 0 1027 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M515.2 0C232.448 0 3.2 229.248 3.2 512s229.248 512 512 512 512-229.248 512-512-229.248-512-512-512z m237.056 534.656c-5.824 5.76-13.824 9.344-22.656 9.344H547.2v182.4c0 17.664-14.336 32-32 32-8.832 0-16.832-3.584-22.656-9.344-5.76-5.824-9.344-13.824-9.344-22.656V544H300.8c-17.664 0-32-14.336-32-32 0-8.832 3.584-16.832 9.344-22.656 5.824-5.76 13.824-9.344 22.656-9.344h182.4V297.6c0-17.664 14.336-32 32-32 8.832 0 16.832 3.584 22.656 9.344 5.76 5.824 9.344 13.824 9.344 22.656V480H729.6c17.664 0 32 14.336 32 32 0 8.832-3.584 16.832-9.344 22.656z",
    fill: "#A594B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFill);
export default __webpack_public_path__ + "static/media/add-fill.565ff3883a3937f981fde8a271f58736.svg";
export { ForwardRef as ReactComponent };